import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MFPurchaseUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getMFPurchaseDetails(data);
    }
}
export default MFPurchaseUseCase;
